import React from 'react';
import CourseGrid from '../components/CourseGrid';

const Courses = () => {
  return (
    <div className="py-16 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Courses
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive coaching programs designed to help you excel in competitive exams
          </p>
        </div>
        
        <CourseGrid />
      </div>
    </div>
  );
};

export default Courses;